import { useTheme } from "@mui/material";
import React from "react";
import "./Textfield1.css";

export interface TextFieldProps {
  id?: string;
  label?: string;
  custom?: boolean;
  className?: string;
  value?: string | number;
  defaultValue?: string | number;
  type?: string;
  required?: boolean;
  autoComplete?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

// TODO: Rename Textfield1 folder back to Textfield after this gets merged to master.

// TODO: Add styling to when textfield disabled
export const Textfield = ({
  label = "",
  custom,
  value,
  defaultValue,
  type = "text",
  autoComplete,
  disabled = false,
  ...props
}: TextFieldProps) => {
  const theme = useTheme();

  if (custom) {
    return (
      <div className="custom-textfield-container">
        <label className="custom-textfield-label">{label}</label>
        <input
          id="textfield"
          name="text"
          type={type}
          value={value}
          defaultValue={defaultValue}
          disabled={disabled}
          className="custom-textfield"
          placeholder={label[0] + label.slice(1).toLowerCase()}
          autoComplete={autoComplete}
          style={{
            marginTop: "10px",
            height: "40px",
            border: "none",
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
          }}
          {...props}
        />
      </div>
    );
  }

  return (
    <input
      onChange={props.onChange}
      className={" textfield ".concat(props.className ?? "")}
      name="text"
      autoComplete={autoComplete}
      type={type}
      disabled={disabled}
      value={value}
      defaultValue={defaultValue}
      style={{
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
      }}
      placeholder={label.concat(props.required ? "*" : "")}
    />
  );
};
